import { type AccessControlConfig } from '../../../../legacy/components/AccessControl/accessControl.utils'
import { WarehouseLocationFeature } from '../../../../legacy/common/warehouseLocations'
import AccessControl from '../../../../legacy/components/AccessControl/AccessControl'
import { Permission } from '../../../../legacy/common/types'

export const ReportsPickupAnalyticsAccessControl: AccessControlConfig = {
  warehouseLocationFeatures: WarehouseLocationFeature.RetailerPickup,
  permissions: AccessControl.oneOf([Permission.Analytics, Permission.PickupAnalytics]),
}
